<template>
  <div class="fieldManage">
    <div class="left">
      <div class="listItem" v-for="(item,index) in itemList" :key="index">{{item.name}}</div>
    </div>
    <div class="right">
      <div class="operation">
        <div class="operationBtn">
          <el-button type="primary" @click="saveFieldProfile">{{this.$t('LanguageLib.SAVE_FIELD')}}</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="primary" @click="addCategory" STYLE="margin: 0">{{this.$t('LanguageLib.ADD_CATEGORYS')}}
          </el-button>
          <el-button type="primary" @click="addField">{{this.$t('LanguageLib.ADD_FIELD')}}</el-button>
        </div>
      </div>
      <div class="fieldView">
        <div class="fieldCate">
          <el-collapse class="cateContainer" v-model="fieldCategorys">
            <div v-for="(item,index) in fieldCategorys" :key="index">
              <el-collapse-item name="index">
                <template slot="title">
                  {{item.name}}
                </template>
                <el-table
                  ref="table"
                  :data="item.children"
                  style="width: 100%">

                  <el-table-column
                  width="50"
                  label="">
                    <template>
                      <i class="iconfont">&#xe61a;</i>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('LanguageLib.FIELD_NAME')"
                    prop="name"
                    width="120">
                  </el-table-column>

                  <el-table-column
                    :label="$t('LanguageLib.FIELD_TYPE')"
                    width="120"
                    prop="fieldType"
                  >
                    <template>
                      {{ this.$commonfun.convertType(fieldType)}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.SYSTEM_FIELD')"
                    width="120">
                  </el-table-column>

                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.LAST_MODI_TIME')"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    type="selection"
                    width="25">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.REQUIRED2')"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    type="selection"
                    width="25">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.ENABLE')"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.PUBLIC')"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.AS_FILTER_KEY')"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('LanguageLib.Operation')"
                    min-width="120">
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="editRole(scope.row, scope.$index, tableData)"
                        v-if="scope.row.isAllowOperation"
                        :title="$t('LanguageLib.Edit')"
                        type="text"
                        style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                        <i class="iconfont">&#xe60c;</i>
                      </el-button>
                      <el-button
                        @click.native.prevent="editRole(scope.row, scope.$index, tableData)"
                        v-if="!scope.row.isAllowOperation"
                        :title="$t('LanguageLib.Edit')"
                        type="text"
                        style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">

                        <i class="iconfont">&#xe60c;</i>
                      </el-button>
                      <el-button
                        @click.native.prevent="editRole(scope.row, scope.$index, tableData)"
                        :title="$t('LanguageLib.Edit')"
                        type="text"
                        style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                        <i class="iconfont">&#xe619;</i>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicdataApic from '../../api/basicdata/index'

export default {
  name: 'FieldManagement',
  data () {
    return {
      fieldCategorys: [], // 分类列表
      rawProfile: {},
      profile: {},
      currentManage: {}, // 店铺字段
      itemList: [{
        name: '店铺字段管理'
      }]
    }
  },
  mounted () {
    this.getFieldProfile()
  },
  methods: {
    saveFieldProfile () {
      basicdataApic.saveFieldProfile('post', '/profile/updatestoreprofile', {})
    },
    getFieldByCate (cateId) {
      const pf = this.currentManage
      const fieldList = pf.storeFields
      const arr = []
      for (let i = 0; i < fieldList.length; i++) {
        if (fieldList[i].categoryId === cateId) {
          arr.push(fieldList[i])
        }
      }
      return arr
    },
    getFieldProfile () {
      basicdataApic.getFieldProfile('get', '/profile/getstoreprofile')
        .then(
          res => {
            this.rawProfile = res.data
            this.profile = this.rawProfile
            this.currentManage = this.profile.storeFieldProfile
            console.log(this.currentManage)
            this.fieldCategorys = this.processCurrentManage(this.currentManage)
            console.log(this.fieldCategorys)
          }
        )
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    addCategory () {
    },
    addField () {
    },
    handleChange (data) {
      console.log(data)
    },
    processCurrentManage (profile) {
      var Categorys = profile.fieldCategorys
      var storeFields = profile.storeFields
      for (let i = 0; i < Categorys.length; i++) {
        var cateItem = Categorys[i]
        cateItem.children = []
        for (let j = 0; j < storeFields.length; j++) {
          var field = storeFields[j]
          if (field.categoryId === cateItem.id) {
            cateItem.children.push(field)
          }
        }
      }
      console.log(Categorys)
      return Categorys
    }
  }
}
</script>

<style lang="scss">
  .fieldManage {
    background: #9de3dc;
    height: 100%;
    width: 100%;
    $basic: 1675;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .cateContainer {
      height: 100%;
      .fieldHeader {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        height: 60px;
        padding: 34px 50px 0 50px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #909399;
        line-height: 14px;
      }

      .headNameColumn {
        display: inline-flex;
        justify-content: center;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #909399;
        line-height: 14px;
      }

      .headTypeColumn {
        display: inline-block;
        width: 6%;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #909399;
        line-height: 14px;
      }
    }

    .el-collapse-item__header {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 14px;
      width: 1307px;
      height: 48px;
      background: #F5F7FA;
      padding-left: 21px;
      border: 1px solid #EBEEF5;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: border-bottom-color .3s;
      outline: 0;
      /* padding-left: 12px; */
    }

    .left {
      border: 1px solid #F0F2F5;
      display: inline-block;
      width: 20%;
      height: 100%;
      padding: 1px;
      background: white;

      .listItem {
        box-sizing: border-box;
        padding: 26px 13px;
        width: 100%;
        height: 48px;
        background: #F5F7FA;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }

    .right {
      .el-divider--vertical {
        height: 30px;
        margin: 0 10px;
      }

      .operation {
        background: #fff;
        height: 30px;
        padding: 10px 0 10px 20px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;

        .operationBtn {
          width: auto;
          display: inline-block;
          float: left;
          position: relative;

          .el-button {
            height: 30px;
            padding: 5px 12px;
          }

          .BatchSetting {
            background: #fff;
            color: #666666;
            position: absolute;
            left: 0;
            top: 30px;
            width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }

          .exportType {
            min-width: 100px;
            background: #fff;
            color: #666666;
            position: absolute;
            right: 0;
            top: 30px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }
        }

        .operationSearch {
          float: right;
          padding-right: 51px;
          position: relative;

          .shaixuan {
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }

          .shaixuan1 {
            color: #3BC6B9;
          }

          .el-input {
            width: 160px;

            .el-input__inner {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }

          .el-icon-search {
            line-height: 30px;
          }
        }
      }

      background: #ffffff;
      display: inline-block;
      width: 80%;
      height: 100%;
    }
  }
</style>
